import { render, staticRenderFns } from "./hot-subject.vue?vue&type=template&id=2282cc7c&scoped=true&"
import script from "./hot-subject.vue?vue&type=script&lang=js&"
export * from "./hot-subject.vue?vue&type=script&lang=js&"
import style0 from "./hot-subject.vue?vue&type=style&index=0&id=2282cc7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2282cc7c",
  null
  
)

export default component.exports